import { PipeTransform } from '@angular/core';
var SortTasksByOrderAndField = /** @class */ /*@__PURE__*/ (function () {
    function SortTasksByOrderAndField() {
    }
    SortTasksByOrderAndField.prototype.transform = function (tasks, sortOrder, sortField) {
        if (sortOrder === void 0) {
            sortOrder = 1;
        }
        if (sortField === void 0) {
            sortField = 'dueDate';
        }
        var result = tasks.sort(function (task1, task2) {
            var v1 = String(task1[sortField]).slice(0, 10);
            var v2 = String(task2[sortField]).slice(0, 10);
            if (v1 < v2) {
                return sortOrder;
            }
            else if (v1 > v2) {
                return -sortOrder;
            }
            else {
                return 0;
            }
            ;
        });
        return result;
    };
    return SortTasksByOrderAndField;
}());
export { SortTasksByOrderAndField };
